import {ProfileHistoryType} from 'common/types/reports/query';
import {DateRangeType} from 'common/types/reports/bookmark';
import {TimeUnit} from 'common/widgets/date-range-picker/models/types';

import {QueryFilterEntry, QuerySegmentEntry} from '../types';

export function getEntryWithProfileHistory<T extends QuerySegmentEntry | QueryFilterEntry>(
  entry: T,
  toType: ProfileHistoryType,
): T {
  return {
    ...entry,
    event: {
      ...entry.event,
      profileHistoryOptions: {
        type: toType,
        dateRange:
          toType === ProfileHistoryType.DateRange
            ? {
                type: DateRangeType.RelativeAfter,
                window: {unit: TimeUnit.Day, value: 30},
              }
            : undefined,
      },
    },
  };
}
